/* Freedom Sale countdown — binds every [data-fs-timer] on the page */
(function () {
  function pad(n){ return n < 10 ? '0' + n : '' + n; }

  function bind(el){
    if (el.__fsBound) return;
    el.__fsBound = true;

    var end = Date.parse(el.getAttribute('data-end'));
    if (isNaN(end)) { el.setAttribute('data-state','expired'); return; }

    var mode = (el.getAttribute('data-expire') || 'message').toLowerCase();
    var n = {};
    ['d','h','m','s'].forEach(function(u){ n[u] = el.querySelector('[data-u="'+u+'"]'); });
    var say = el.querySelector('[data-fs-announce]');
    var last = {}, lastMin = -1, id;

    function paint(u,v){
      var e = n[u];
      if (!e || last[u] === v) return;
      last[u] = v;
      e.textContent = v;
      e.classList.remove('is-tick');
      void e.offsetWidth;
      e.classList.add('is-tick');
    }

    function tick(){
      var left = end - Date.now();
      if (left <= 0){
        clearInterval(id);
        el.setAttribute('data-state','expired');
        ['d','h','m','s'].forEach(function(u){ paint(u,'00'); });
        if (mode === 'hide'){
          var wrap = el.closest ? el.closest('.fs-strip-wrap') : null;
          (wrap || el).style.display = 'none';
        }
        if (say) say.textContent = 'The sale has ended.';
        return;
      }
      var t = Math.floor(left/1000),
          d = Math.floor(t/86400),
          h = Math.floor((t%86400)/3600),
          m = Math.floor((t%3600)/60),
          s = t%60;
      paint('d',pad(d)); paint('h',pad(h)); paint('m',pad(m)); paint('s',pad(s));
      if (say && m !== lastMin){
        lastMin = m;
        say.textContent = 'Sale ends in ' + d + ' days, ' + h + ' hours, ' + m + ' minutes.';
      }
    }

    tick();
    id = setInterval(tick, 1000);
    document.addEventListener('visibilitychange', function(){ if (!document.hidden) tick(); });
  }

  function init(){
    var l = document.querySelectorAll('[data-fs-timer]');
    for (var i = 0; i < l.length; i++) bind(l[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();


/* ── small PDP urgency pill ──────────────────────────────────────────
   mode="daily"  counts to the next midnight IST, never past the sale end
   mode="date"   counts straight to data-end
   Both are real deadlines — nothing per-visitor or resettable.          */
(function () {
  var IST = 19800000, DAY = 86400000;

  function pad(n){ return n < 10 ? '0' + n : '' + n; }

  function nextIstMidnight(){
    var shifted = Date.now() + IST;
    return (Math.floor(shifted / DAY) * DAY + DAY) - IST;
  }

  function bindPill(el){
    if (el.__fsPill) return;
    el.__fsPill = true;

    var out  = el.querySelector('[data-fs-pill-time]');
    var mode = (el.getAttribute('data-mode') || 'daily').toLowerCase();
    var hard = Date.parse(el.getAttribute('data-end'));
    if (isNaN(hard)) hard = Infinity;
    var id;

    function target(){
      if (mode === 'date') return hard;
      return Math.min(nextIstMidnight(), hard);
    }

    function tick(){
      var left = target() - Date.now();
      if (left <= 0){
        if (Date.now() >= hard){ clearInterval(id); el.setAttribute('hidden',''); return; }
        left = target() - Date.now();          /* rolled past midnight — re-aim */
      }
      var t = Math.floor(left / 1000),
          d = Math.floor(t / 86400),
          h = Math.floor((t % 86400) / 3600),
          m = Math.floor((t % 3600) / 60),
          s = t % 60;
      if (out) out.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
    }

    tick();
    id = setInterval(tick, 1000);
    document.addEventListener('visibilitychange', function(){ if (!document.hidden) tick(); });
  }

  function initPills(){
    var l = document.querySelectorAll('[data-fs-pill]');
    for (var i = 0; i < l.length; i++) bindPill(l[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPills);
  else initPills();
  document.addEventListener('shopify:section:load', initPills);
})();


/* ── header rotator: crossfades the message and the countdown ── */
(function () {
  function bindRot(el){
    if (el.__fsRot) return;
    el.__fsRot = true;
    var slides = el.querySelectorAll('.fsh-slide');
    if (slides.length < 2) return;
    var i = 0, ms = parseInt(el.getAttribute('data-interval'), 10) || 4000;
    setInterval(function () {
      slides[i].classList.remove('is-on');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-on');
    }, ms);
  }
  function initRot(){
    var l = document.querySelectorAll('[data-fsh-rot]');
    for (var i = 0; i < l.length; i++) bindRot(l[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initRot);
  else initRot();
  document.addEventListener('shopify:section:load', initRot);
})();
